import * as angular from "angular";

export class FilterService {
    private apiRoot: string;
    private $http: any;

    constructor($http: any, __env: any) {
        this.$http = $http;
        this.apiRoot = __env.apiUrl() + "/filter";
    }

    all(): Promise<object> {
        return this.$http.get(this.apiRoot + "/all");
    }

    create(data: any): Promise<object> {
        return this.$http.post(this.apiRoot + "/create", data);
    }
    delete(data: any): Promise<object> {
        return this.$http.delete(this.apiRoot + "/" + data.id);
    }

    deleteGroupFilter(gid: any): Promise<object> {
        return this.$http.delete(this.apiRoot + "/group_filter/" + gid);
    }
}

angular.module("vcServices").service("FilterService", FilterService);
